// Summary And Greeting Section
import emoji from "react-easy-emoji";

const greeting = {
  username: "Jhon Bellido",
  greetingText: "Hola, Yo soy ",
  greetingName: "Jhon",
  subTitle: emoji("Desarrollador web y móvil"),
  resumeLink: "../../assets/cv_Bellido_Jhon.pdf",
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/jhonbellidovargas/",
  linkedin: "https://www.linkedin.com/in/jhonbellidovargas/",
  gmail: "jhon.strivex@gmail.com",
  twitter: "https://twitter.com/Jhonb88165374/",
  whatsapp: "https://api.whatsapp.com/send?phone=5195892970",
  wt: "https://wa.me/51958929700?text=Hola%20Jhon%20quiero%20mas%20información%20sobre%20tu%20trabajo",
};

// Skills Section

const skillsSection = {
  title: "Lo que puedo hacer",
  subTitle:
    "Me encanta enfrentar nuevos retos y desarrollar soluciones innovadoras. Siempre estoy buscando mejorar mis habilidades y conocimientos.",
  skills: [
    emoji("Autodidacta"),
    emoji("Desarrollo web y móvil"),
    emoji("Solución de problemas"),
    emoji("Amante de la tecnología"),
    emoji("Buenas prácticas de desarrollo"),
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
  https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    // {
    //   skillName: "Html 5",
    //   fontAwesomeClassname: "fab fa-html5",
    //   id: "html-5",
    // },
    // {
    //   skillName: "css3",
    //   fontAwesomeClassname: "fab fa-css3-alt",
    //   id: "css3",
    // },
    {
      skillName: "javascript",
      fontAwesomeClassname: "fab fa-js",
      id: "js",
    },
    {
      skillName: "angular",
      fontAwesomeClassname: "fab fa-angular",
      id: "angular",
    },
    {
      skillName: "reactjs",
      fontAwesomeClassname: "fab fa-react",
      id: "reactjs",
    },
    {
      skillName: "nodejs",
      fontAwesomeClassname: "fab fa-node",
      id: "nodejs",
    },
    {
      skillName: "Flutter",
      fontAwesomeClassname: "fas fa-mobile-alt",
      id: "flutter",
    },
    {
      skillName: "nestJs",
      fontAwesomeClassname: "fas fa-code",
      id: "nestjs",
    },
    {
      skillName: "sql-database",
      fontAwesomeClassname: "fas fa-database",
      id: "sql",
    },
    {
      skillName: "mongoDb",
      fontAwesomeClassname: "fas fa-leaf",
      id: "mongodb",
    },
    {
      skillName: "git",
      fontAwesomeClassname: "fab fa-git",
      id: "git",
    },
    {
      skillName: "github",
      fontAwesomeClassname: "fab fa-github",
      id: "github",
    },
    {
      skillName: "bootstrap",
      fontAwesomeClassname: "fab fa-bootstrap",
      id: "bootstrap",
    },
    {
      skillName: "sass",
      fontAwesomeClassname: "fab fa-sass",
      id: "sass",
    },
    {
      skillName: "azure",
      fontAwesomeClassname: "fab fa-windows",
      id: "azure",
    },
  ],
};

// Work experience section
const certifications = {
  certifications: [
    {
      title: "Ingeniería de Sistemas",
      subtitle: "- Bachiller",
      logo_path: "logounsch.png",
      certificate_link: "https://enlinea.sunedu.gob.pe/",
      alt_name: "unsch",
      color_code: "#c5ccf3",
    },
    {
      title: "Microsoft Certified: Azure Fundamentals",
      subtitle: "- AZ-900",
      logo_path: "azure.png",
      certificate_link:
        "https://www.credly.com/badges/26e35282-03af-4825-9017-b23fd55e60d9/public_url",
      alt_name: "Azure-Fundamentals",
      color_code: "#c5ccf3",
    },
    {
      title: "Escuela de JavaScript",
      subtitle: "- Fullstack",
      logo_path: "platzi.png",
      certificate_link:
        "https://platzi.com/p/JhonStvX/learning-path/100-escuela-javascript/diploma/detalle/",
      alt_name: "platzi",
      color_code: "#c5ccf3",
    },
    {
      title: "Desarrollador Web Frontend",
      subtitle: "- Frontend",
      logo_path: "certus.png",
      certificate_link: "",
      alt_name: "Certus",
      color_code: "#c5ccf3",
    },
    {
      title: "Curso de React Avanzado",
      subtitle: "- Frontend",
      logo_path: "platzi.png",
      certificate_link:
        "https://platzi.com/p/JhonStvX/curso/1601-react-avanzado/diploma/detalle/",
      alt_name: "platzi",
      color_code: "#c5ccf3",
    },
    {
      title: "Aprende React + Firebase | 2021 ",
      subtitle: "- Fullstack",
      logo_path: "udemy.png",
      certificate_link:
        "https://www.udemy.com/certificate/UC-3afc267b-fbc9-41ab-9c20-6e0db4784b86/",
      alt_name: "udemy",
      color_code: "#c5ccf3",
    },
    // {
    //   title: "Diseño de redes - Basado en CCDA",
    //   subtitle: "- Redes",
    //   logo_path: "udemy.png",
    //   certificate_link:
    //     "https://www.udemy.com/certificate/UC-a5b52f18-b82a-4e9a-9309-e6941a221ea0/",
    //   alt_name: "udemy",
    //   color_code: "#c5ccf3",
    // },
    // {
    //   title: "SQL for Data Science",
    //   subtitle: "- courses",
    //   logo_path: "coursera.png",
    //   certificate_link:
    //     "https://www.coursera.org/account/accomplishments/verify/YHZVLK4CE789",
    //   alt_name: "coursera",
    //   color_code: "#F0FFDD",
    // },
    // {
    //   title: "Curso Profesional de Next.js",
    //   subtitle: "- Frontend",
    //   logo_path: "platzi.png",
    //   certificate_link:
    //     "https://platzi.com/p/JhonStvX/curso/2707-profesional-nextjs/diploma/detalle/",
    //   alt_name: "platzi",
    //   color_code: "#c5ccf3",
    // },
    // {
    //   title: "Data Modeling",
    //   subtitle: "- MongoDB",
    //   logo_path: "mongodb.png",
    //   certificate_link:
    //     "https://university.mongodb.com/courses/M320/2021_May_25/completion",
    //   alt_name: "MongoDB University",
    //   color_code: "#FEF6E6",
    // },
    {
      title: "Curso de Backend con Node.js: API REST con Express.js",
      subtitle: "- Backend",
      logo_path: "platzi.png",
      certificate_link:
        "https://platzi.com/p/JhonStvX/curso/2485-backend-nodejs/diploma/detalle/",
      alt_name: "platzi",
      color_code: "#c5ccf3",
    },
    // {
    //   title: "MongoDB for JavaScript Developers",
    //   subtitle: "- MongoDB",
    //   logo_path: "mongodb.png",
    //   certificate_link:
    //     "https://university.mongodb.com/courses/M220JS/2021_May_25/completion",
    //   alt_name: "MongoDB University",
    //   color_code: "#FDE9EA",
    // },
    {
      title: "Frontend con Angular",
      subtitle: "- Frontend",
      logo_path: "platzi.png",
      certificate_link:
        "https://platzi.com/p/JhonStvX/ruta/7045-web-angular/diploma/detalle/",
      alt_name: "platzi",
      color_code: "#c5ccf3",
    },
  ],
};

const openSource = {
  githubConvertedToken: process.env.REACT_APP_GITHUB_TOKEN,
  githubUserName: "bhavinvirani", // Change to your github username to view your profile in Contact Section.
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true, // Set false to hide this section, defaults to true
};

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt",
  blogs: [
    {
      url: "https://dev.to/bhavinvirani/getting-started-with-git-1jlj",
      title: "Getting Started with 'Git'",
      description:
        "Git is a version control system (VCS) that makes easier to track changes to files(code). For example, when you edit a file, git can help you to determine...",
    },
    {
      url: "https://dev.to/bhavinvirani/2d-vector-in-c-23gh",
      title: " about Mongoose",
      description:
        "MnongoDB provides it's native driver to work with our project at server side but it may be large amount of code or repetition in code but...",
    },
    {
      url: "https://dev.to/bhavinvirani/vector-in-c-4550",
      title: "Vector in C++",
      description:
        "Vectors in C++ are sequence containers representing arrays that can change their size during runtime. They use contiguous storage locations for their elements...",
    },
    {
      url: "https://dev.to/bhavinvirani/2d-vector-in-c-23gh",
      title: "2D Vector in C++",
      description:
        "We can define 2D Vector as Vector of Vector followed by N number of rows where each of the row is individual a vector...",
    },
  ],
  display: true, // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle: "¿Quieres saber más de mí? No dudes en contactarme!",
  email_address: "jhon.strivex@gmail.com",
};

export {
  greeting,
  socialMediaLinks,
  skillsSection,
  openSource,
  blogSection,
  contactInfo,
  certifications,
};
